declare var BASE_URL:string;
declare var STATIC_BASE_URL:string;
declare var ga;

import '../styles/main.scss';
import '../styles/animate.scss';

import Router from 'preact-router';
import { h, Component } from 'preact';
import Header from './header';
import Footer from './footer';
import Home from './Home';
import Omnichannel from './Omnichannel';
import Onlineleadgen from './Onlineleadgen';
import Chatbotassistant from './Chatbotassistant';
import Enterprisesolution from './Enterprisesolution';
import Aisociallab from './Aisociallab';
import Forbes from './Forbes';
import Forbesleadinsights from './Forbeshrassistant';
import Forbeshrassistant from './Forbesleadinsights';
import Chatbotstudio from './Chatbotstudio';
import Contacts from "./Contacts";
import Careers from "./Careers";
import Forbesresearch from "./Forbesresearch";
import Partners from "./Partners";
import Becomeapartner from "./Becomeapartner";
import About from "./About";
import Youtubepopup from "./youtubePopup";
/*import Register from "./Register";
import Login from "./Login";*/

export default class Website extends Component<any, any> {

  constructor() {
    super();
  }

  private handleRoute = e => {
    window.scrollTo(0,0);
    if (typeof ga !== 'undefined') ga('send', 'pageview');
    this.toggleMenu('close');
  };

  private headerCB = e => {
    console.log('headercb');
    e.preventDefault();
    this.toggleMenu('');
  };

  private toggleMenu (type: string) {
    if (this.state.menuOpen || type === 'close') {
      this.setState({menuOpen: ''});
      document.removeEventListener('mousedown', this.handleClickOutside);
    } else if (!this.state.menuOpen) {
      this.setState({menuOpen: 'openMenu'});
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }

  private handleClickOutside = event => {

    if (this.state.menuOpen) {
      let found = false;

      if (event.target.className.indexOf('menuItemCheck') !== -1) {
        found = true;
      } else if (event.target.parentNode.className.indexOf('menuItemCheck') !== -1) {
        found = true;
      } else if (event.target.parentNode.parentNode.className.indexOf('menuItemCheck') !== -1) {
        found = true;
      } else if (event.target.parentNode.parentNode.parentNode.className.indexOf('menuItemCheck') !== -1) {
        found = true;
      } else if (event.target.parentNode.parentNode.parentNode.parentNode.className.indexOf('menuItemCheck') !== -1) {
        found = true;
      } else if (event.target.parentNode.parentNode.parentNode.parentNode.parentNode.className.indexOf('menuItemCheck') !== -1) {
        found = true;
      }

      if (!found) {
        console.log('prevented default')
        this.toggleMenu('close');
      }
    }

  };
  
  private closeYt() {
    this.setState({'ytData': null});
  }
  
  private handleYTRequest (id) {
    this.setState({'ytData': id});
  }

  public render (props, state): any {

    return <div class={ state.menuOpen }>
      <Header cb={ this.headerCB } />
      <div role="main">
        <Router onChange={ this.handleRoute.bind(this) }>
          <Home path="./" ytCB={ this.handleYTRequest.bind(this) } default />
          <About path={ BASE_URL + 'about'} />
            <Forbesleadinsights path={ BASE_URL + 'products/hr-assistant' } />
            <Forbeshrassistant path={ BASE_URL + 'products/forbes-lead-insights' } />
            <Omnichannel path={ BASE_URL + 'products/omni-channel' } />
            <Chatbotstudio ytCB={ this.handleYTRequest.bind(this) } path={ BASE_URL + 'products/chatbot-studio' } />
            <Chatbotassistant ytCB={ this.handleYTRequest.bind(this) } path={ BASE_URL + 'products/chatbot-assistant' } />
            <Enterprisesolution path={ BASE_URL + 'products/enterprise-solution' } />
            <Aisociallab path={ BASE_URL + 'products/ai-social-lab' } />
            <Onlineleadgen ytCB={ this.handleYTRequest.bind(this) } path={ BASE_URL + 'products/online-lead-gen' } />
          <Careers path={ BASE_URL + 'careers' } />
          <Partners path={ BASE_URL + 'partners/list' } />
          <Becomeapartner path={ BASE_URL + 'partners/join' } />
          {/*<Partners path={ BASE_URL + 'partners/ibm' } />
          <Partners path={ BASE_URL + 'partners/microsoft' } />*/}
          <Forbes path={ BASE_URL + 'forbes-insights' } />
          <Forbesresearch path={ BASE_URL + 'forbes-insights/research' } />
          <Forbes path={ BASE_URL + 'partners/forbes-insights' } />
          <Contacts path={ BASE_URL + 'contacts' } />
        </Router>
      </div>
      <Footer />
      { state.ytData ? <Youtubepopup data={ state.ytData } cb={ this.closeYt.bind(this) } /> : '' }
      <script async src={ STATIC_BASE_URL + 'js/embeds/dist/app.js' }></script><div id="querloEmbd" class="querlo" data-id="LeadGenDemo" data-width="200" data-height="400" data-pos-x="right" data-pos-y="bottom" data-template="esd" data-main-color="rgb(41,149,225)" data-speaker-img={ STATIC_BASE_URL + 'image_uploads/avatar1/251197_5c52cdbab7405_png.png'} data-speaker-name="Querlo" data-intro-txt="Want more customers?" data-delay=""></div>

    </div>
  }
}


// WEBPACK FOOTER //
// ./ts/Website.tsx